import React from 'react'
import { useSelector } from 'react-redux';
import { EditPage } from '@equipedigitalfloripa/ed-cms/components';
//import { fetchCasino, editCasino, uploadCasino } from '../api/casinos'
import * as contentsApi from '../api/content'

const EditContent = ({edit}) => {
  const translations = useSelector(state => state.translations.translations['system-contents'])
  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name:"title",
      type:"text",
      title: "Título da página",
      validation: {
        required: true
      },
    },
    {
      name: 'content',
      type: 'tiny',
      title: "Conteúdo da página"
    }
  ]
  return (
    // <EditPage selectedData={selectedData} apiFunctions={casinoApi} fetchFunction={fetchCasino} editFunction={editCasino} uploadFunction={uploadCasino} edit={true} url='casinos'/>
    <EditPage
      title={"Página de conteúdo"}
      subtitle={""}
      selectedData={selectedData} 
      fetchFunction={contentsApi.fetchItem} 
      editFunction={contentsApi.editItem} 
      edit={edit} 
      url='contents'
    />
  )
}

export default EditContent
